// @flow
import React from 'react'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import {
  actions as favoriteActions,
  type State as FavoriteState,
} from 'redux/modules/favorite'
import { setUIState, containerIds } from 'redux/modules/ui'
import Path from 'routes/path'
import MainTemplate from 'components/templates/MainTemplate'
import { headerFragment } from 'common/fragments/www'
import FavoriteListPage from 'components/pages/FavoriteListPage'
import { accountLoginUrl } from 'frontend_core/dist/helpers/url'

type PropTypes = {
  favorite: FavoriteState,
  localUser: {
    username: string,
  },
  ui: {
    newListName: boolean,
    isSubmittedCreateNewListName: boolean,
    isOpenFavoriteListCreateModal: boolean,
    isOpenDeleteFavoriteItemModal: boolean,
    newfavoriteListName: string,
  },
  data: Object,
  actions: {
    fetchFavoriteList: Function,
    createFavoriteList: Function,
    setUIState: Function,
  },
}

class FavoriteListPageContainer extends React.Component<PropTypes> {
  static async getInitialProps({ req, res, params, config, isLogin }) {
    if (!isLogin)
      return { redirect: { to: accountLoginUrl(config), status: 302 } }
    return
  }

  constructor(props: PropTypes) {
    super(props)
    props.actions.setUIState(containerIds.FAVORITE, {
      isOpenFavoriteListCreateModal: false,
      isSubmittedCreateNewListName: false,
      isOpenDeleteFavoriteItemModal: false,
      newListName: '',
    })
  }
  componentDidMount() {
    const { actions, favorite } = this.props
    actions.fetchFavoriteList({
      userId: this.props.localUser.username,
      silent: favorite.isSuccessFetchFavoriteList,
    })
  }

  componentDidUpdate(prevProps: PropTypes) {
    const { favorite } = this.props
    const {
      failedFetchFavoriteListMessage,
      failedCreateFavoriteListMessage,
    } = favorite

    if (
      failedFetchFavoriteListMessage &&
      !prevProps.favorite.failedFetchFavoriteListMessage
    ) {
      message.warning(failedFetchFavoriteListMessage)
    }

    if (
      failedCreateFavoriteListMessage &&
      !prevProps.favorite.failedCreateFavoriteListMessage
    ) {
      message.warning(failedCreateFavoriteListMessage)
    }
  }

  render() {
    const { actions, localUser, ui } = this.props
    const {
      favoriteList,
      isSuccessFetchFavoriteList,
      failedFetchFavoriteListMessage,
    } = this.props.favorite
    const {
      newListName,
      isSubmittedCreateNewListName,
      isOpenFavoriteListCreateModal,
      isOpenDeleteFavoriteItemModal,
    } = ui
    const title = i18n.t('server.www.favoriteList.title')

    return (
      <MainTemplate
        title={title}
        description={i18n.t('server.shared.default_description', { title })}
        hideMustHeader
        {...this.props}
      >
        <FavoriteListPage
          favoriteList={favoriteList}
          isLoading={
            !isSuccessFetchFavoriteList && !failedFetchFavoriteListMessage
          }
          onClickCreateList={() => {
            actions.createFavoriteList({
              userId: localUser.username,
              name: newListName,
            })
            actions.setUIState(containerIds.FAVORITE, {
              isOpenFavoriteListCreateModal: false,
              newListName: '',
            })
          }}
          onClickOpenModal={() => {
            actions.setUIState(containerIds.FAVORITE, {
              isOpenFavoriteListCreateModal: true,
            })
          }}
          onClickCloseModal={() => {
            actions.setUIState(containerIds.FAVORITE, {
              isOpenFavoriteListCreateModal: false,
            })
          }}
          isOpenFavoriteListCreateModal={isOpenFavoriteListCreateModal}
          newListName={newListName}
          isSubmittedCreateNewListName={isSubmittedCreateNewListName}
          onChangeNewListName={(e: SyntheticInputEvent<*>) => {
            actions.setUIState(containerIds.FAVORITE, {
              newListName: e.target.value,
            })
          }}
          onSubmitCreateNewListName={() => {
            actions.setUIState(containerIds.FAVORITE, {
              isSubmittedCreateNewListName: true,
            })
          }}
          isOpenDeleteFavoriteItemModal={isOpenDeleteFavoriteItemModal}
          onClickCloseDeleteFavoriteItemModal={() => {
            actions.setUIState(containerIds.FAVORITE, {
              isOpenDeleteFavoriteItemModal: false,
            })
          }}
        />
      </MainTemplate>
    )
  }
}

const headerQuery = gql`
query HeaderQuery {
  ${headerFragment}
}
`

const withData = graphql(headerQuery)(FavoriteListPageContainer)

function mapStateToProps(state: Object) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, ...favoriteActions }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withData),
)



// WEBPACK FOOTER //
// ./src/containers/pages/FavoriteListPage.jsx